import React from 'react';
import './QuizComplete.css';

interface QuizCompleteProps {
  score: number;
  totalQuestions: number;
  onRestart: () => void;
}

const QuizComplete: React.FC<QuizCompleteProps> = ({ score, totalQuestions, onRestart }) => {
  const percentage = Math.round((score / totalQuestions) * 100);
  
  const getFirefighterLevel = () => {
    if (percentage >= 90) {
      return {
        title: "🌟 Fantastično!",
        message: "Si pravi gasilski strokovnjak! Odlično poznaš svojo stvar!",
        emoji: "🏆",
        color: "#4facfe",
        image: "🚒👨‍🚒",
        level: "Gasilski strokovnjak",
        description: "Poznaš vse gasilske termine in si pripravljen za vsak izziv!"
      };
    } else if (percentage >= 80) {
      return {
        title: "🎉 Odlično!",
        message: "Izjemno delo! Res se učiš gasilskega znanja!",
        emoji: "⭐",
        color: "#f093fb",
        image: "🚒👨‍🚒",
        level: "Izkušen gasilec",
        description: "Odlično poznaš gasilske termine in si skoraj strokovnjak!"
      };
    } else if (percentage >= 70) {
      return {
        title: "👍 Odlično delo!",
        message: "Dobro opravljeno! Učiš se veliko kul gasilskih dejstev!",
        emoji: "🎯",
        color: "#a8edea",
        image: "🚒👨‍🚒",
        level: "Gasilec",
        description: "Dobro poznaš osnove gasilstva in se učiš naprej!"
      };
    } else if (percentage >= 60) {
      return {
        title: "💪 Dobr poskus!",
        message: "Lepo delo! Nadaljuj z učenjem in boš gasilski strokovnjak!",
        emoji: "🌱",
        color: "#ffecd2",
        image: "🚒👦",
        level: "Gasilski učenec",
        description: "Učiš se gasilskih veščin in si na dobri poti!"
      };
    } else {
      return {
        title: "🌱 Nadaljuj z učenjem!",
        message: "Vsak gasilec je nekoč začel nekje! Nadaljuj z raziskovanjem in učenjem!",
        emoji: "📚",
        color: "#ff6b6b",
        image: "🚒👶",
        level: "Gasilski začetnik",
        description: "Začneš svojo pot do postanka gasilskega strokovnjaka!"
      };
    }
  };

  const final = getFirefighterLevel();

  return (
    <div className="quiz-complete-container">
      <div className="completion-card">
        <div className="completion-header">
          <div className="firefighter-image">{final.image}</div>
          <h1 className="completion-title" style={{ color: final.color }}>
            {final.title}
          </h1>
          <div className="firefighter-level" style={{ color: final.color }}>
            {final.level}
          </div>
        </div>
        
        <div className="score-summary">
          <div className="final-score">
            <span className="score-number">{score}</span>
            <span className="score-total">/{totalQuestions}</span>
          </div>
          <div className="percentage">
            {percentage}% Pravilno
          </div>
        </div>
        
        <div className="completion-message">
          {final.message}
        </div>
        
        <div className="firefighter-description">
          {final.description}
        </div>
        
        <div className="celebration">
          <div className="confetti">🎊</div>
          <div className="confetti">🎉</div>
          <div className="confetti">✨</div>
          <div className="confetti">🌟</div>
        </div>
        
        <button 
          className="restart-button"
          onClick={onRestart}
        >
          <span className="button-icon">🔄</span>
          Igraj znova
        </button>
      </div>
    </div>
  );
};

export default QuizComplete;

